export { default } from './Subheading';
